import React, { useState } from 'react';
import ConfirmModal from './ConfirmModal.js';
import Footer from '../Footer/Footer.js';
import { Helmet } from 'react-helmet-async';
import { ReactComponent as DownArrow } from '../../assets/down-arrow.svg';
import { ReactComponent as Checkmark } from '../../assets/checkmark.svg';
import { programs } from '../../assets/programs.js';

const Packages = (props) => {

    const context = props.context

    // console.log("****Packages.js - context", context)

    const [modalIsOpen,setIsOpen] = useState(false);
    const [newItem, setNewItem] = useState({})

    async function openModal() {
        setIsOpen(true);
    }

    function closeModal(){
        setIsOpen(false);
    }

    const [columnA, setColumnA] = useState(programs.compare)
    const [columnB, setColumnB] = useState(programs[context.userChoice] || programs["weight_loss"])

    const [columnAsession, setColumnAsession] = useState(columnA.session[0])
    const [columnBsession, setColumnBsession] = useState(columnB.session[0])

    const [compareButton, setCompareButton] = useState(true)

    // useEffect(() => {
    //     updateContext(cart, setCart, userChoice, setUserChoice, context)
    // }, [cart, userChoice])

    function sleep(ms) {
        return new Promise(res => setTimeout(res, ms));
    }

    const select = async function (e, input){
        e.preventDefault()
        const program = e.target.dataset.value
        // close session option dropdown
        var option = document.getElementById(`session-options-${input}`)
        var arrow = document.getElementById(`session-arrow-${input}`)
        if (option.style.display === "block"){
            arrow.style.transform = "rotate(0deg)"
            option.style.display = "none"
        }       
        if (input === "a"){
            setColumnA(programs[program])
            setColumnAsession(programs[program].session[0])
        } else if (input === "b"){
            setColumnB(programs[program])
            setColumnBsession(programs[program].session[0])
        }
        var item = document.getElementsByClassName(`column-${input}`)
        for (let i = 0; i < (item.length - 1); i++){
            item[i].firstChild.style.display = "none"
        }
        toggleDropdown(input);
        await sleep(1)
        for (let i = 0; i < (item.length - 1); i++){
            item[i].firstChild.style.display = "flex"
        }
    }

    const toggleDropdown =  async function (input){
        var arrow = document.getElementById(`arrow-${input}`)
        var option = document.getElementById(`options-${input}`)

        if (input === "a" && compareButton){
            setCompareButton(false)
            arrow.style.visibility = "visible"
            var columnAdivs = document.getElementsByClassName("column-a")
            for (let i = 0; i <= columnAdivs.length - 1; i++){
                columnAdivs[i].style.visibility = "visible"
            }
            setColumnA(programs.get_fit)
            setColumnAsession(columnA.session[0]) //Need to set columnAsession to remap/rerender, default price set for now
        }
        if (option.style.display === "block"){
            for (let i = 4; i >= 1; i--){
                var optionItem = document.getElementById(`option-${input}${i}`)
                optionItem.style.animation = `closeUp ${i}50ms ease-in-out`
            }
            arrow.style.transform = "rotate(0deg)"
            await sleep(100);
            option.style.display = "none"
        } else {
            for (let i = 1; i <= 4; i++){
                var optionItemReset = document.getElementById(`option-${input}${i}`)
                optionItemReset.style.animation = `growDown ${i}00ms ease-in-out`
            }
            option.style.display = "block"
            option.style.animation = "none"
            arrow.style.transform = "rotate(180deg)";
        }
    }

    const toggleSessionDropdown =  async function (input, optionsLength, close = false){
        var option = document.getElementById(`session-options-${input}`)
        var arrow = document.getElementById(`session-arrow-${input}`)
        if (option.style.display === "block"){
            // for (let i = optionLength; i >= 1; i--){ //disabled, adding animation value to wrong element?
            //     var optionItem = document.getElementById(`session-option-${input}${i}`)
            //     optionItem.style.animation = `closeUp ${i}50ms ease-in-out`
            // }
            arrow.style.transform = "rotate(0deg)"
            await sleep(100);
            option.style.display = "none"
        } else {
            for (let i = 1; i <= optionsLength; i++){
                var optionItemReset = document.getElementById(`session-option-${input}${i}`)
                optionItemReset.style.animation = `growDown ${i}00ms ease-in-out`
            }
            option.style.display = "block"
            option.style.animation = "none"
            arrow.style.transform = "rotate(180deg)";
        }
    }

    const selectSession = async function (e, input){
        e.preventDefault()
        const session = e.target.dataset.value
        let optionsLength = 0;        
        if (input === "a"){
            setColumnAsession(columnA.session[session])
            optionsLength = columnA.session.length
        } else if (input === "b"){
            setColumnBsession(columnB.session[session])
            optionsLength = columnB.session.length
        }
        toggleSessionDropdown(input, optionsLength);
    }

    const addToCart = async function(e, input){
        e.preventDefault()
        let item = {}
        if (input === "a"){
            item = {
                name: columnA.name,
                description: columnAsession.name,
                price: columnAsession.price,
                quantity: 1,
                add_six_weeks: columnAsession.add_six_weeks,
                schedule_link: "https://calendly.com/iglf/initial-consultation"
            }
        } else if (input === "b"){
            item = {
                name: columnB.name,
                description: columnBsession.name,
                price: columnBsession.price,
                quantity: 1,
                add_six_weeks: columnBsession.add_six_weeks,
                schedule_link: "https://calendly.com/iglf/initial-consultation"
            }
        }

        setNewItem(item)
        context.actions.addToCart(item)
        openModal();
    }

    return (
            <div className="container-page" id="packages">
                <Helmet>
                    <meta charSet="utf-8" />
                    <meta name="description" content="It's A Good Life Fitness" />
                    <title>It's A Good Life Fitness | Packages</title>
                    <link rel="canonical" href="https://itsagoodlifefitness.com" />
                </Helmet>
                <div className="packages-header">
                    <h1 role="main">Compare Packages</h1>
                </div>
                <div className="packages-container">
                    <div className="dropdown-container">
                        <div className="dropdowns">
                            <div className="dropdown" id="column-a" style={{visibility: ""}}>
                                <div className="column-selected" onClick={()=> toggleDropdown("a")} role="button" aria-label="General" aria-pressed="false" tabIndex="0">
                                    <div className="column-selected-name">{columnA.name}</div>
                                    <div className="column-arrow" id="arrow-a"><span><DownArrow /></span></div>
                                </div>
                                <div className="options" id="options-a">
                                    <div className="option-1" id="option-a1" onClick={(e)=> select(e, "a")} role="button" aria-label="General" aria-pressed="false" tabIndex="0" data-value="stay_fit">Stay Fit</div>
                                    <div className="borderline"></div>
                                    <div className="option-2" id="option-a2" onClick={(e)=> select(e, "a")} role="button" aria-label="General" aria-pressed="false" tabIndex="0" data-value="weight_loss">Weight Loss</div>
                                    <div className="borderline"></div>
                                    <div className="option-3" id="option-a3" onClick={(e)=> select(e, "a")} role="button" aria-label="General" aria-pressed="false" tabIndex="0" data-value="get_fit">Get Fit</div>
                                    <div className="borderline"></div>
                                    <div className="option-4" id="option-a4" onClick={(e)=> select(e, "a")} role="button" aria-label="General" aria-pressed="false" tabIndex="0" data-value="keep_moving">Keep Moving</div>
                                </div>
                            </div>
                            <div className="dropdown">
                                <div className="column-selected" onClick={()=> toggleDropdown("b")} role="button" aria-label="General" aria-pressed="false" tabIndex="0">
                                    <div className="column-selected-name">{columnB.name}</div>
                                    <div className="column-arrow" id="arrow-b"><span><DownArrow /></span></div>
                                </div>
                                <div className="options" id="options-b">
                                    <div className="option-1" id="option-b1" onClick={(e)=> select(e, "b")} role="button" aria-label="General" aria-pressed="false" tabIndex="0" data-value="stay_fit">Stay Fit</div>
                                    <div className="borderline"></div>
                                    <div className="option-2" id="option-b2" onClick={(e)=> select(e, "b")} role="button" aria-label="General" aria-pressed="false" tabIndex="0" data-value="weight_loss">Weight Loss</div>
                                    <div className="borderline" id="option-1"></div>
                                    <div className="option-3" id="option-b3" onClick={(e)=> select(e, "b")} role="button" aria-label="General" aria-pressed="false" tabIndex="0" data-value="get_fit">Get Fit</div>
                                    <div className="borderline"></div>
                                    <div className="option-4" id="option-b4" onClick={(e)=> select(e, "b")} role="button" aria-label="General" aria-pressed="false" tabIndex="0" data-value="keep_moving">Keep Moving</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="item">
                        <div className="item-header">
                            <h2>Getting To Know You</h2>
                        </div>
                        <div className="line-item-1">
                            <p>Wellness Assessment</p>
                            <div className="column-a">{columnA.wellness_assessment ? (<Checkmark />) : (<div className="unchecked">-</div>)}</div>
                            <div className="column-b">{columnB.wellness_assessment ? (<Checkmark />) : (<div className="unchecked">-</div>)}</div>
                        </div>
                        <div className="line-item-2">
                            <p>Physical Readiness for Exercise</p>
                            <div className="column-a">{columnA.physical_readiness ? (<Checkmark />) : (<div className="unchecked">-</div>)}</div>
                            <div className="column-b">{columnB.physical_readiness ? (<Checkmark />) : (<div className="unchecked">-</div>)}</div>
                        </div>
                        <div className="line-item-3">
                            <p>Movement Assessment</p>
                            <div className="column-a">{columnA.movement_assessment ? (<Checkmark />) : (<div className="unchecked">-</div>)}</div>
                            <div className="column-b">{columnB.movement_assessment ? (<Checkmark />) : (<div className="unchecked">-</div>)}</div>
                        </div>
                        <div className="line-item-4">
                            <p>Goal Development</p>
                            <div className="column-a">{columnA.goal_development ? (<Checkmark />) : (<div className="unchecked">-</div>)}</div>
                            <div className="column-b">{columnB.goal_development ? (<Checkmark />) : (<div className="unchecked">-</div>)}</div>
                        </div>
                        <div className="line-item-5">
                            <p>Review Habits for Lifestyle Change</p>
                            <div className="column-a">{columnA.review_habits ? (<Checkmark />) : (<div className="unchecked">-</div>)}</div>
                            <div className="column-b">{columnB.review_habits ? (<Checkmark />) : (<div className="unchecked">-</div>)}</div>
                        </div>
                    </div>
                    {/* *************** */}
                    <div className="item">
                        <div className="item-header">
                            <h2>Metabolic Testing</h2>
                        </div>
                        <div className="line-item-6">
                            <p>Inbody Body Comp</p>
                            <div className="column-a">{columnA.inbody_body_comp ? (<Checkmark />) : (<div className="unchecked">-</div>)}</div>
                            <div className="column-b">{columnB.inbody_body_comp ? (<Checkmark />) : (<div className="unchecked">-</div>)}</div>
                        </div>
                        <div className="line-item-7">
                            <p>Resting Metabolic Rate</p>
                            <div className="column-a">{columnA.resting_metabolic_rate ? (<Checkmark />) : (<div className="unchecked">-</div>)}</div>
                            <div className="column-b">{columnB.resting_metabolic_rate ? (<Checkmark />) : (<div className="unchecked">-</div>)}</div>
                        </div>
                        <div className="line-item-8">
                            <p>VO2 Max Test</p>
                            <div className="column-a">{columnA.vo2_max ? (<Checkmark />) : (<div className="unchecked">-</div>)}</div>
                            <div className="column-b">{columnB.vo2_max ? (<Checkmark />) : (<div className="unchecked">-</div>)}</div>
                        </div>
                    </div>
                    {/* *************** */}
                    <div className="item">
                        <div className="item-header">
                            <h2>Nutrition Coaching</h2>
                        </div>
                        <div className="line-item-9">
                            <p>Initial 1 Hour Consultation</p>
                            <div className="column-a">{columnA.initial_consulation ? (<Checkmark />) : (<div className="unchecked">-</div>)}</div>
                            <div className="column-b">{columnB.initial_consulation ? (<Checkmark />) : (<div className="unchecked">-</div>)}</div>
                        </div>
                        <div className="line-item-10">
                            <p>Meal Plan Development</p>
                            <div className="column-a">{columnA.meal_plan_development ? (<Checkmark />) : (<div className="unchecked">-</div>)}</div>
                            <div className="column-b">{columnB.meal_plan_development ? (<Checkmark />) : (<div className="unchecked">-</div>)}</div>
                        </div>
                        <div className="line-item-11">
                            <p>Shopping List</p>
                            <div className="column-a">{columnA.shopping_list ? (<Checkmark />) : (<div className="unchecked">-</div>)}</div>
                            <div className="column-b">{columnB.shopping_list ? (<Checkmark />) : (<div className="unchecked">-</div>)}</div>
                        </div>
                        <div className="line-item-12">
                            <p>30 Minute Virtual Touchpoint Meetings</p>
                            <div className="column-a">{columnA.thirty_minute_virtual_touchpoint ? (<Checkmark />) : (<div className="unchecked">-</div>)}</div>
                            <div className="column-b">{columnB.thirty_minute_virtual_touchpoint ? (<Checkmark />) : (<div className="unchecked">-</div>)}</div>
                        </div>
                        <div className="line-item-13">
                            <p>15 Minute Virtual Touchpoint Meetings</p>
                            <div className="column-a">{columnA.fifteen_minute_virtual_touchpoint ? (<div className="checkmark"><div className="unchecked">{columnA.fifteen_minute_virtual_touchpoint}</div></div>) : (<div className="unchecked">-</div>)}</div>
                            <div className="column-b">{columnB.fifteen_minute_virtual_touchpoint ? (<div className="checkmark"><div className="unchecked">{columnB.fifteen_minute_virtual_touchpoint}</div></div>) : (<div className="unchecked">-</div>)}</div>
                        </div>
                    </div>
                    {/* *************** */}
                    <div className="item">
                        <div className="item-header">
                            <h2>Personal Training</h2>
                        </div>
                        <div className="line-item-14">
                            <p>Training Plan Development</p>
                            <div className="column-a">{columnA.training_plan_development ? (<Checkmark />) : (<div className="unchecked">-</div>)}</div>
                            <div className="column-b">{columnB.training_plan_development ? (<Checkmark />) : (<div className="unchecked">-</div>)}</div>
                        </div>
                        <div className="line-item-15">
                            <p>30 Minute Virtual Personal Training</p>
                            <div className="column-a">{columnA.thirty_minute_virtual_pt ? (<div className="checkmark"><div className="unchecked">{columnA.thirty_minute_virtual_pt}</div></div>) : (<div className="unchecked">-</div>)}</div>
                            <div className="column-b">{columnB.thirty_minute_virtual_pt ? (<div className="checkmark"><div className="unchecked">{columnB.thirty_minute_virtual_pt}</div></div>) : (<div className="unchecked">-</div>)}</div>
                        </div>
                        <div className="line-item-16">
                            <p>60 Minute Virtual Personal Training</p>
                            <div className="column-a">{columnA.sixty_minute_virtual_pt ? (<div className="checkmark"><div className="unchecked">{columnA.sixty_minute_virtual_pt}</div></div>) : (<div className="unchecked">-</div>)}</div>
                            <div className="column-b">{columnB.sixty_minute_virtual_pt ? (<div className="checkmark"><div className="unchecked">{columnB.sixty_minute_virtual_pt}</div></div>) : (<div className="unchecked">-</div>)}</div>
                        </div>
                    </div>
                    {/* *************** */}
                    <div className="item">
                        <div className="item-header">
                            <h2>Wellness Portal</h2>
                        </div>
                        <div className="line-item-17">
                            <p>Communicate With Coaches</p>
                            <div className="column-a">{columnA.communicate_with_coaches ? (<Checkmark />) : (<div className="unchecked">-</div>)}</div>
                            <div className="column-b">{columnB.communicate_with_coaches ? (<Checkmark />) : (<div className="unchecked">-</div>)}</div>
                        </div>
                        <div className="line-item-18">
                            <p>Access Eductational Content</p>
                            <div className="column-a">{columnA.access_educational_content ? (<Checkmark />) : (<div className="unchecked">-</div>)}</div>
                            <div className="column-b">{columnB.access_educational_content ? (<Checkmark />) : (<div className="unchecked">-</div>)}</div>
                        </div>
                        <div className="line-item-19">
                            <p>Track Progress</p>
                            <div className="column-a">{columnA.track_progress ? (<Checkmark />) : (<div className="unchecked">-</div>)}</div>
                            <div className="column-b">{columnB.track_progress ? (<Checkmark />) : (<div className="unchecked">-</div>)}</div>
                        </div>
                        <div className="line-item-20">
                            <p>Access Recipes</p>
                            <div className="column-a">{columnA.access_recipes ? (<Checkmark />) : (<div className="unchecked">-</div>)}</div>
                            <div className="column-b">{columnB.access_recipes ? (<Checkmark />) : (<div className="unchecked">-</div>)}</div>
                        </div>
                        <div className="line-item-21">
                            <p>Create Healthy Habits</p>
                            <div className="column-a">{columnA.create_healthy_habits ? (<Checkmark />) : (<div className="unchecked">-</div>)}</div>
                            <div className="column-b">{columnB.create_healthy_habits ? (<Checkmark />) : (<div className="unchecked">-</div>)}</div>
                        </div>
                    </div>
                    {/* *************** */}
                    <div className="item">
                        <div className="item-header">
                            <h2>Session Type - Length</h2>
                        </div>
                        <div className="line-item-22">
                            <p>Upgrade Your Virtual Session Length<br />or Go In Person!</p>
                            <div className="column-a">
                                <div className="session-dropdown-container">
                                    <div className="session-dropdown">
                                        <div className="column-selected" onClick={()=> toggleSessionDropdown("a")} role="button" aria-label="General" aria-pressed="false" tabIndex="0">
                                            <div className="column-selected-name">{columnAsession.name}</div>
                                            <div className="column-arrow" id="session-arrow-a"><span><DownArrow /></span></div>
                                        </div>
                                        <div className="options" id="session-options-a">
                                            {columnA.session.map((option, index) =>{
                                                return (
                                                    <div className={`option-${index + 1}`} id={`session-option-a${index + 1}`} key={index} onClick={(e)=> selectSession(e, "a")} role="button" aria-label="General" aria-pressed="false" tabIndex="0" data-value={index}>{option.name}</div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="column-b">
                                <div className="session-dropdown-container">
                                    <div className="session-dropdown">
                                        <div className="column-selected" onClick={()=> toggleSessionDropdown("b")} role="button" aria-label="General" aria-pressed="false" tabIndex="0">
                                            <div className="column-selected-name">{columnBsession.name}</div>
                                            <div className="column-arrow" id="session-arrow-b"><span><DownArrow /></span></div>
                                        </div>
                                        <div className="options" id="session-options-b">
                                            {columnB.session.map((option, index) =>{
                                                return (
                                                    <div className={`option-${index + 1}`} id={`session-option-b${index + 1}`} key={index} onClick={(e)=> selectSession(e, "b")} role="button" aria-label="General" aria-pressed="false" tabIndex="0" data-value={index}>{option.name}</div>
                                                )
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* *************** */}
                    
                    <div className="total">
                        <div className="total-header">
                            <h2>Total</h2>
                        </div>
                            <div className="column-a">
                                <div className="name">{columnA.name}</div>
                                <div className="price">${columnAsession.price}</div>
                                <button className="button" onClick={(e) => addToCart(e, "a")}>Add To Cart</button>
                            </div>
                            <div className="column-b">
                                <div className="name">{columnB.name}</div>
                                <div className="price">${columnBsession.price}</div>
                                <button className="button" onClick={(e) => addToCart(e, "b")}>Add To Cart</button>
                            </div>
                    </div>
                    {/* *************** */}
                </div>
                <ConfirmModal modalIsOpen={modalIsOpen} closeModal={closeModal} newItem={newItem} context={context} props={props} />
                <Footer {...props} />
            </div>
    )
}

export default Packages;